import { Start } from './bootstrap';

// Block all scripts from loading from this point forward.
const metaElem = document.createElement('meta');
metaElem.setAttribute('http-equiv', 'Content-Security-Policy');
metaElem.setAttribute('content', `script-src 'none'`);
document.head.appendChild(metaElem);

// Assume the most evil of scripts will run in this iframe. Don't let it have any chance of storing anything.
// Scrape out ALL persistent state so this thing can't do jack. Even if we accidentally had things on this domain.
try {
  document['cookie'] = '';
  if (window.localStorage) {
    // Nuke local storage.
    window.localStorage.clear();
  }
  if (window.sessionStorage) {
    // Nuke session storage.
    window.sessionStorage.clear();
  }
} catch (e) {
  console.log(e);
}

// SENTINEL GUARD COMMENT DO NOT REMOVE
Start();
